"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = require("react");
var _memoizeOne = _interopRequireDefault(require("memoize-one"));
var _Context = _interopRequireDefault(require("../../Context"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const getExperiments = (0, _memoizeOne.default)((experiments, variants) => experiments.reduce((acc, experiment) => {
  acc[experiment] = variants[experiment] || null;
  return acc;
}, {}));

/**
 * Custom React Hook to get multiple Laquesis experiments variant at once
 * It also triggers `window.isVariantEnabled` on client side when the functional component is used.
 *
 * @param {Array<string>} experiments - The experiment ids array
 * @param {{enable:boolean}} [options={ enable: true }] Right now it only has the option `enable`.
 *    The `enable` option is a precondition of the hook, since hooks can't be executed with conditionals.
 *    The default value is `true`, if it is false it disable the hook execution (returns undefined and no `test_impression` is sent).
 * @return {Object.<string, string>} Contains the key-value pairs of given experiments and their respective variant values
 */
const useMultipleExperiments = (experiments, {
  enable
} = {
  enable: true
}) => {
  experiments = experiments.map(experiment => experiment.toUpperCase());
  const {
    variants,
    isVariantEnabled,
    trackOrder,
    isDelayedTracking
  } = (0, _react.useContext)(_Context.default);

  // make sure during component re-renders that we only send one test impression
  // also prepare for React 18 https://stackoverflow.com/questions/72238175/react-18-useeffect-is-getting-called-two-times-on-mount
  const testImpressionSent = (0, _react.useRef)(false);
  (0, _react.useEffect)(() => {
    if (enable && !testImpressionSent.current && experiments?.length > 0 && variants) {
      experiments.forEach(experiment => {
        if (variants[experiment]) {
          isVariantEnabled(experiment, variants[experiment], isDelayedTracking?.(), trackOrder);
        }
      });
      testImpressionSent.current = true;
    }
  }, [experiments, variants, isVariantEnabled, enable, isDelayedTracking, trackOrder]);
  if (!enable) {
    return {};
  }
  return getExperiments(experiments, variants);
};
var _default = useMultipleExperiments;
exports.default = _default;